import { useEffect, useState } from 'react';
import type { BuildsSearch } from '@/router';

/** The text filters that commit to the URL after a pause. */
export type TextFilterKey = 'q' | 'branch';

/**
 * A text input bound to one search param: it follows the param when the URL changes and commits typed text after a
 * pause (the selects commit immediately). An empty text clears the param.
 */
export function useCommittedText(key: TextFilterKey, search: BuildsSearch, onChange: (next: BuildsSearch) => void): [string, (v: string) => void] {
  const current = search[key];
  const [text, setText] = useState(current ?? '');
  useEffect(() => setText(current ?? ''), [current]);
  useEffect(() => {
    const t = setTimeout(() => {
      if ((text || undefined) !== search[key]) onChange({ ...search, [key]: text || undefined });
    }, 350);
    return () => clearTimeout(t);
  }, [text]);
  return [text, setText];
}
